// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessStep_root__3-JZY","pic":"SuccessStep_pic__3gKob","head":"SuccessStep_head__2KZpz","details":"SuccessStep_details__3mYu8","actions":"SuccessStep_actions__1KCNG"};